import { render, staticRenderFns } from "./VideoItems4Template.vue?vue&type=template&id=a95165d2"
import script from "./VideoItems4Template.vue?vue&type=script&lang=js"
export * from "./VideoItems4Template.vue?vue&type=script&lang=js"
import style0 from "./VideoItems4Template.vue?vue&type=style&index=0&id=a95165d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports